var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.445,
    height: 23.237,
    viewBox: "0 0 23.445 23.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_17460982641645479140",
    "data-name": 17460982641645480000,
    transform: "translate(-32.898 -42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43861",
    "data-name": "Path 43861",
    d: "M92.45,235.62a4.315,4.315,0,0,1-2.779-1.02,4.3,4.3,0,0,1-5.557,0,4.3,4.3,0,0,1-5.557,0,4.289,4.289,0,0,1-3.89.871v9.008a2.847,2.847,0,0,0,2.779,2.9h1.111v-8.133a.569.569,0,0,1,.556-.581H83a.569.569,0,0,1,.556.581v8.133h7.225a2.847,2.847,0,0,0,2.779-2.9v-9.008A4.277,4.277,0,0,1,92.45,235.62Zm-2.779,5.955a.569.569,0,0,1-.556.581H86.892a.569.569,0,0,1-.556-.581v-2.324a.569.569,0,0,1,.556-.581h2.223a.569.569,0,0,1,.556.581Z",
    transform: "translate(-39.493 -181.48)",
    fill: "#bec4ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43862",
    "data-name": "Path 43862",
    d: "M266.667,52.086a3.471,3.471,0,0,0,4.647,0v-3.2a4.068,4.068,0,0,0-.062-.708l-.972-5.509h-3.613Z",
    transform: "translate(-221.592)",
    fill: "#bec4ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43863",
    "data-name": "Path 43863",
    d: "M160,48.883v3.2a3.471,3.471,0,0,0,4.647,0V42.667h-3.613l-.972,5.509A4.064,4.064,0,0,0,160,48.883Z",
    transform: "translate(-120.481)",
    fill: "#bec4ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43864",
    "data-name": "Path 43864",
    d: "M361.265,48.749h0L359.424,43.8a1.75,1.75,0,0,0-1.633-1.135h-3.113l.937,5.308a5.239,5.239,0,0,1,.079.909v3.2a3.481,3.481,0,0,0,5.633-1.5A2.792,2.792,0,0,0,361.265,48.749Z",
    transform: "translate(-305.111)",
    fill: "#bec4ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43865",
    "data-name": "Path 43865",
    d: "M38.658,48.883a5.24,5.24,0,0,1,.079-.909l.937-5.307H36.561A1.75,1.75,0,0,0,34.928,43.8l-1.841,4.947a2.794,2.794,0,0,0-.061,1.841,3.481,3.481,0,0,0,5.633,1.5Z",
    transform: "translate(0 0)",
    fill: "#bec4ca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.ffeeccdab3e4a888274cfca0f0945a0e.svg";
export { ForwardRef as ReactComponent };